// extracted by mini-css-extract-plugin
export default {"btnpwd":"_392da65a5d"};